<div class="editor" #editor placeholder="Write your question here..."></div>
